/**
 * @file utils/errorHandler.ts store 中使用
 */
import {messageManager} from '@/utils/errorHandler/MessageManager';
import {baseHandleError} from './baseHandleError';

export interface IHandleRequestErrorOptions {
    error: unknown;
    customMessage?: string;
    message?: any;
    notification?: any;
    modal?: any;
    navigate?: (path: string) => void;
    messageConfig?: {
        className?: string;
        style?: React.CSSProperties;
        duration?: number;
    };
}

/**
 * 统一错误处理函数
 * 默认使用 messageManager 中的 notification（来自 useApp）
 * 也可以可通过 message 替代 notification
 */
export async function handleRequestError(options: IHandleRequestErrorOptions) {
    const {
        error,
        customMessage,
        message,
        notification = messageManager.notification,
        modal = messageManager.modal,
        navigate,
        messageConfig = {}
    } = options;

    // 默认使用 notification，如果没有则使用 message
    const displayApi = message || notification;

    const result = await baseHandleError(error, {
        messageApi: displayApi,
        modalApi: modal,
        navigate,
        customMessage,
        messageConfig
    });

    return result;
}
